"use client";

import { useAnimate, useInView } from "framer-motion";
import { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

export default function Topline({
    align,
    children,
    className,
}: {
    align?: string;
    children: React.ReactNode;
    className?: string;
}) {
    const component = useRef<HTMLDivElement>(null);

    const [scope, animate] = useAnimate();
    const isInView = useInView(scope);

    useEffect(() => {
        if (isInView) {
            animate([
                [".topline", { opacity: 1 }],
                [".line", { width: "40px" }, { at: "-0.15" }],
            ]);
        }
    }, [isInView, animate]);

    return (
        <p
            className={cn("text-brand font-medium inline-flex items-center gap-4", className)}
            ref={scope}
        >
            <span className='topline opacity-0'>{children}</span>
            <span className='line w-0 h-px bg-[currentColor] block'></span>
        </p>
    );
}
